import { type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import type { AssetsListingBaseLabel, AssetsListingCMSConfig, AssetsListingListing, AssetsListingMap, AssetsListingView } from '4-sections/AssetsListing/AssetsListingContext';
export { VIEW_LISTING, VIEW_MAP } from '4-sections/AssetsListing/AssetsListingContext';

import type { Locales } from 'cms/cms-types';
import React from 'react';

interface RealEstateMapCardLabel {
    sectorLabel: string;
    stateLabel: string;
    gradeLabel: string;
    statusLabel: string;
}

interface RealEstateListingLabel extends AssetsListingBaseLabel, RealEstateMapCardLabel {
    title: string;
    mapViewSwitchTitle: string;
    listViewSwitchTitle: string;
    filterHeading: string;
    clearFilterButton: string;
    sectorLabel: string;
    stateLabel: string;
    gradeLabel: string;
    statusLabel: string;
    readMoreCardLabel: string;
}

export interface RealEstateListingProps {
    cms: AssetsListingCMSConfig;
    locale?: Locales;
    label: RealEstateListingLabel;
    map: AssetsListingMap;
    listing: AssetsListingListing;
}

export type RealEstateListingView = AssetsListingView;

export interface RealEstateListingContextProps extends RealEstateListingProps, ListingFiltersState {
    view: RealEstateListingView;
    setView: React.Dispatch<React.SetStateAction<RealEstateListingView>>;
    activeItemId: string;
    setActiveItemId: React.Dispatch<React.SetStateAction<string>>;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    filterModalOpen: boolean;
    setFilterModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RealEstateListingContext = React.createContext<Partial<RealEstateListingContextProps>>({});

export default RealEstateListingContext;
